import PropTypes from 'prop-types';
import mark from '../assets/brand-mark.svg';

export default function Brand({ compact = false, large = false }) {
  return <span className={`rf-brand ${large ? 'rf-brand-large' : ''}`}>
    <img src={mark} width={large ? 44 : 32} height={large ? 44 : 32} alt="" />
    {!compact && <span className="rf-brand-wordmark">Rota<span>Flex</span></span>}
  </span>;
}
Brand.propTypes = { compact: PropTypes.bool, large: PropTypes.bool };
